var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmapWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1052,
    height: 36,
    viewBox: "0 0 1052 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 18.6173C33.9254 -3.29107 62.665 -3.29107 91.4028 18.6173C120.142 40.5258 148.88 40.5258 177.619 18.6173C206.357 -3.29107 235.096 -3.29107 263.834 18.6173C292.573 40.5258 321.311 40.5258 350.05 18.6173C378.788 -3.29107 407.527 -3.29107 436.266 18.6173C465.004 40.5258 493.742 40.5258 522.481 18.6173C551.22 -3.29107 579.958 -3.29107 608.697 18.6173C637.435 40.5258 666.174 40.5258 694.912 18.6173C723.651 -3.29107 752.389 -3.29107 781.128 18.6173C809.866 40.5258 838.605 40.5258 867.341 18.6173C896.079 -3.29107 924.817 -3.29107 953.563 18.6173C982.301 40.5258 1011.04 40.5258 1039.78 18.6173",
    stroke: "url(#paint0_linear_1_356)",
    strokeWidth: 1.72963,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78809 22.0767C11.1315 22.0767 13.8418 19.3663 13.8418 16.023C13.8418 12.6796 11.1315 9.96924 7.78809 9.96924C4.44472 9.96924 1.73438 12.6796 1.73438 16.023C1.73438 19.3663 4.44472 22.0767 7.78809 22.0767Z",
    fill: "url(#paint1_linear_1_356)",
    stroke: "#1A1F22",
    strokeWidth: 3.45927
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.71 21.2124C357.053 21.2124 359.764 18.5021 359.764 15.1587C359.764 11.8153 357.053 9.10498 353.71 9.10498C350.367 9.10498 347.656 11.8153 347.656 15.1587C347.656 18.5021 350.367 21.2124 353.71 21.2124Z",
    fill: "url(#paint2_linear_1_356)",
    stroke: "#101315",
    strokeWidth: 3.45927
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.632 21.2124C702.975 21.2124 705.686 18.5021 705.686 15.1587C705.686 11.8153 702.975 9.10498 699.632 9.10498C696.288 9.10498 693.578 11.8153 693.578 15.1587C693.578 18.5021 696.288 21.2124 699.632 21.2124Z",
    fill: "url(#paint3_linear_1_356)",
    stroke: "#202951",
    strokeWidth: 3.45927
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.83 21.2124C1047.18 21.2124 1049.89 18.5021 1049.89 15.1587C1049.89 11.8153 1047.18 9.10498 1043.83 9.10498C1040.49 9.10498 1037.78 11.8153 1037.78 15.1587C1037.78 18.5021 1040.49 21.2124 1043.83 21.2124Z",
    fill: "url(#paint4_linear_1_356)",
    stroke: "#202951",
    strokeWidth: 3.45927
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_356",
    x1: -13.5099,
    y1: 15.6962,
    x2: 988.765,
    y2: 243.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10A9E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_356",
    x1: 0.428671,
    y1: 16.023,
    x2: 14.9099,
    y2: 15.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22CD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_356",
    x1: 346.351,
    y1: 15.1587,
    x2: 360.832,
    y2: 15.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22CD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_356",
    x1: 692.272,
    y1: 15.1587,
    x2: 706.754,
    y2: 15.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22CD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_356",
    x1: 1036.48,
    y1: 15.1587,
    x2: 1050.96,
    y2: 15.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22CD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1052,
    height: 34.8496,
    fill: "white",
    transform: "translate(0 0.847168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapWave);
export default __webpack_public_path__ + "static/media/roadmap-wave.3748d6c3300afba3d85cf89a2c0921ae.svg";
export { ForwardRef as ReactComponent };